'use strict';

export class itemModel
{
	
	constructor(itemData){
		this.setupItemData(itemData);
	}
	
	setupItemData(data){
		for(let i in data){
			this[i] = data[i];
		}

	}
	
}